export const testAttributes = {
    LEARNING_CENTER_SOURCE_ID_LINK: 'learning_center_source_id_link',
    LEARNING_CENTER_SOURCE_ID_LOGIC_WITH_COOKIE: 'learning_center_source_id_logic_with_cookie',
    LEARNING_CENTER_SOURCE_ID_LOGIC_WITHOUT_COOKIE: 'learning_center_source_id_logic_without_cookie'
}